module.exports = __webpack_public_path__ + "static/media/features-split-image-03.d0abfa36.png";